import { env } from '../../lib/env/env';

export const fullstoryConfig = {
  FULLSTORY_ORG_ID: '1PQ10',
  FULLSTORY_ENABLED: env.getString('FULLSTORY_ENABLED') || false,
};
